import Toastify from 'toastify-js'

const showToastify = (message, opts) => {
	Toastify({
		duration: 3000,
		position: "center",
		style: { background: "linear-gradient(to right, rgba(18, 41, 64, 1), rgba(69, 115, 154, 1))" },
		text: message,
		...opts
	}).showToast();
}

export default showToastify